import React, { useEffect, useState } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FProveedorUsuarioStyle } from "./styles";
import { useFormik } from "formik";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { newUsuariosAction, updateUsuarioAction, obtenerUsuariobyIdAction } from "./../../../ducks/usuariosDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI";
import { phoneRegExp } from "../../../utils/yupCustomShema";

const validationSchema = yup.object({
  email: yup
    .string("Ingresa un email")
    .email("Email invalido")
    .required("Email es requerido"),
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  apellidoPaterno: yup
    .string("Ingresa un apellido paterno")
    .required("Ingresa un apellido paterno"),
  apellidoMaterno: yup.string("Ingresa un apellido materno").optional(),
  telefono: yup
    .string("Ingresa un telefono")
    .matches(phoneRegExp, "Numero de telefono invalido")
    .required("Telefono es requerido"),
  password: yup.string().required("Contraseña es requerido").min(8, "Minimo 8 caracteres"),
  confPassword: yup.string().oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir'),
});
const validationSchemaActulizacion = yup.object({
  email: yup
    .string("Ingresa un email")
    .email("Email invalido")
    .optional(),
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  apellidoPaterno: yup
    .string("Ingresa un apellido paterno")
    .required("Ingresa un apellido paterno"),
  apellidoMaterno: yup.string("Ingresa un apellido materno").optional(),
  telefono: yup
    .string("Ingresa un telefono")
    .matches(phoneRegExp, "Numero de telefono invalido")
    .required("Telefono es requerido"),
  password: yup.string().optional().min(8, "Minimo 8 caracteres"),
  confPassword: yup.string().optional().oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir'),
  extensionContacto: yup.string("Ingresa una extension")
  .required("Extension es requerido"),
});

const InitalValues = {
  email: "",
  nombre: "",
  apellidoPaterno: "",
  apellidoMaterno: "",
  telefono: "",
  password: "",
  confPassword: "",
  extensionContacto: ""
};

const FProveedorUsuarios = (props) => {
  const {
    open = true,
    setOpen = () => { },
    rowData = {},
    editar = false,
    setEditar = () => { },
  } = props;

  const catalogoRol = useApi("Role/catalog");
  const catalogoTipoUsuario = useApi("Catalog/TipoUsuario");
  const dispatch = useDispatch();
  const classes = FProveedorUsuarioStyle();
  const [isLoad, setIsLoad] = useState(false);
  const [rol, setRol] = useState(0);
  const [tipoUsuario, setTipoUsuario] = useState(0);
  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: (!editar) ? validationSchema : validationSchemaActulizacion,
    onSubmit: (values) => {
      (editar) ? onUpdate(values) : onSave(values)
    },
  });

  const onUpdate = (values) => {
    setIsLoad(true);
    let Informacion = {
      Nombre: values.nombre,
      ApellidoPaterno: values.apellidoPaterno,
      ApellidoMaterno: values.apellidoMaterno,
      Telefono: values.telefono,
      TipoUsuario: Number(tipoUsuario),
      ExtensionContacto: values.extensionContacto
    }
    let Rol = {
      Id: rol
    }
    let payload = {
      Rol,
      PasswordHash: values.password,
      Email: values.email,
      Informacion,
      EditarEmail: (values.email !== rowData.Email) ? true : false
    };
    dispatch(updateUsuarioAction(rowData.Id, payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }
  const onSave = (values) => {
    setIsLoad(true);
    let Informacion = {
      Nombre: values.nombre,
      ApellidoPaterno: values.apellidoPaterno,
      ApellidoMaterno: values.apellidoMaterno,
      Telefono: values.telefono,
      TipoUsuario: Number(tipoUsuario),
      ExtensionContacto: values.extensionContacto
    }
    let Rol = {
      Id: rol
    }
    let payload = {
      Rol,
      PasswordHash: values.password,
      Email: values.email,
      Informacion
    };
    dispatch(newUsuariosAction(payload)).then((Response) => {
      switch (Response.status) {
        case 500:
          ToastMessage.fire({
            icon: "error",
            title: "Ha habido un problema de conexión con el servidor",
          });
          break;
        case 400:
          ToastMessage.fire({
            icon: "warning",
            title: "<strong>Atención</strong>",
            text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
          });
          break;
        default:
          handleClose();
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          });
          break;
      }
      setIsLoad(false);
    });
  }

  useEffect(() => {
    const buscarById = () => {
      setIsLoad(true);
      dispatch(obtenerUsuariobyIdAction(rowData.Id)).then(
        (Response) => {
          formik.setFieldValue("email", Response.Email);
          if (Response.Informacion) {
            const Informacion = Response.Informacion;
            formik.setFieldValue("nombre", Informacion.Nombre)
            formik.setFieldValue("apellidoPaterno", Informacion.ApellidoPaterno)
            formik.setFieldValue("apellidoMaterno", Informacion.ApellidoMaterno)
            formik.setFieldValue("telefono", Informacion.Telefono)
            formik.setFieldValue("extensionContacto", Informacion?.ExtensionContacto)
            setTipoUsuario(Informacion.TipoUsuario);
          }
          setRol((Response.Rol) ? Response.Rol.Id : 0);
          setIsLoad(false);
        }
      );
    };
    if (editar) buscarById();
    return () => {
      LimpiarForm();
    };
  }, [editar, rowData.Id, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const LimpiarForm = () => {
    formik.resetForm(InitalValues);
    setRol(0);
    setTipoUsuario(0);
  };
  const handleClose = () => {
    setOpen(!open);
    setEditar(false);
    LimpiarForm();
  };
  const handleSelecRol = (event) => {
    setRol(event.target.value);
  };
  const handleSelecTipoUsuario = (event) => {
    setTipoUsuario(event.target.value);
  }
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={editar ? "Actuliza usuario" : "Nuevo usuario"}
      />
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={4}>
            <TextField
              required
              id="input-Nombre"
              label="Nombre"
              type="text"
              variant="outlined"
              name="nombre"
              value={formik.values.nombre}
              onChange={formik.handleChange}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={formik.touched.nombre && formik.errors.nombre}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-apPaterno"
              label="Apellido paterno"
              type="text"
              variant="outlined"
              name="apellidoPaterno"
              value={formik.values.apellidoPaterno}
              onChange={formik.handleChange}
              error={
                formik.touched.apellidoPaterno &&
                Boolean(formik.errors.apellidoPaterno)
              }
              helperText={
                formik.touched.apellidoPaterno && formik.errors.apellidoPaterno
              }
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-apMaterno"
              label="Apellido materno"
              type="text"
              variant="outlined"
              name="apellidoMaterno"
              value={formik.values.apellidoMaterno}
              onChange={formik.handleChange}
              error={
                formik.touched.apellidoMaterno &&
                Boolean(formik.errors.apellidoMaterno)
              }
              helperText={
                formik.touched.apellidoMaterno && formik.errors.apellidoMaterno
              }
              className={classes.textField}
            />
          </Grid>
          {
            (!editar) &&
            <Grid item xs={4}>
              <TextField
                required
                id="input-email"
                label="Correo"
                type="text"
                variant="outlined"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                className={classes.textField}
              />
            </Grid>
          }
          <Grid item xs={4}>
            <TextField
              required
              id="input-telfono"
              label="Teléfono"
              type="text"
              variant="outlined"
              name="telefono"
              value={formik.values.telefono}
              onChange={formik.handleChange}
              error={formik.touched.telefono && Boolean(formik.errors.telefono)}
              helperText={formik.touched.telefono && formik.errors.telefono}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              id="input-telfono-extension"
              label="Extensión"
              type="text"
              variant="outlined"
              name="extensionContacto"
              value={formik.values.extensionContacto}
              onChange={formik.handleChange}
              error={formik.touched.extensionContacto && Boolean(formik.errors.extensionContacto)}
              helperText={formik.touched.extensionContacto && formik.errors.extensionContacto}
              className={classes.textField}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lRol">Rol</InputLabel>
              <Select
                labelId="lRol"
                id="SRol"
                name="rol"
                value={rol}
                onChange={handleSelecRol}
                label="Rol"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoRol.map((item, index) => (
                  <MenuItem key={item.Id} value={item.Id}>
                    {item.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="lTipoUsuario">Tipo Usuario</InputLabel>
              <Select
                labelId="lTipoUsuario"
                id="STipoUsuario"
                name="tipoUsuario"
                value={tipoUsuario}
                onChange={handleSelecTipoUsuario}
                label="Tipo Usuario"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoTipoUsuario.map((item, index) => (
                  <MenuItem key={item.IdTipoUsuario} value={item.IdTipoUsuario}>
                    {item.Descripion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {
            (!editar) &&
            <Grid item xs={4}>
              <TextField
                required
                id="input-password"
                label="Contraseña"
                type="password"
                variant="outlined"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                className={classes.textField}
              />
            </Grid>
          }
          {
            (!editar) &&
            <Grid item xs={4}>
              <TextField
                required
                id="input-conf-password"
                label="Confirmar contraseña"
                type="password"
                variant="outlined"
                name="confPassword"
                value={formik.values.confPassword}
                onChange={formik.handleChange}
                error={formik.touched.confPassword && Boolean(formik.errors.confPassword)}
                helperText={formik.touched.confPassword && formik.errors.confPassword}
                className={classes.textField}
              />
            </Grid>
          }
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.modalBoton}
            >
              {editar ? "Actulizar" : "Guardar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </form>
    </ModalBase>
  );
};
export default FProveedorUsuarios;
